import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';

@inject('appStore')
@observer
export default class PermissionHelper extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        {
            if (this.props.appStore.permissionStore.can(this.props.permission)) {
                return React.cloneElement(this.props.children, {});
            } else {
                if (this.props.behavior) {
                    return React.cloneElement(this.props.children, { ...this.props.behavior });
                } else {
                    return null;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/permission-wrapper.js